import deposit from '../../fields/cases/deposit';

export const MUTATION_UPDATE_D_CASE = /* GraphQL */ `
	mutation($input: DepositCaseUpdate!, $id: String!) {
		updateDepositCase(input: $input, id: $id) {
			${deposit}
		}
	}
`;
